import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { aquaApi } from '../api/aquaApi'
import { handleAxiosCodeError, handleAxiosError } from '../helpers/handleAxiosError'

const saveData = async <T, S>(body: T, url: string) => {
  const { data } = await aquaApi.post<S>(url, body)
  return data
}

interface Args<T, S> {
  url: string
  onSuccess?: (data: S, body: T) => void
  onError?: (values: { msg: string; code: number | null }) => void
}

export const usePost = <T, S = unknown>({ url, onSuccess, onError }: Args<T, S>) => {
  const { data, error, isPending, mutate, isSuccess } = useMutation({
    mutationKey: [url],
    mutationFn: (body: T) => saveData<T, S>(body, url),
    onSuccess(data, body) {
      if (onSuccess) onSuccess(data, body)
    },
    onError(error: AxiosError) {
      console.log(error.response?.data)
      if (onError)
        onError({
          msg: handleAxiosError(error),
          code: handleAxiosCodeError(error),
        })
    },
  })

  const handleSendData = (body: T) => {
    mutate(body)
  }

  return {
    handleSendData,
    data,
    isLoading: isPending,
    isSuccess,
    msgError: handleAxiosError(error as AxiosError),
    codeError: handleAxiosCodeError(error as AxiosError),
  }
}
